(function () {
  function snap(val, step, min) {
    const n = parseInt(val, 10);
    const base = isNaN(n) ? min : Math.max(min, n);
    return Math.ceil(base / step) * step; // round UP to next multiple
  }

  function onSnap(e) {
    const input = e.target;
    if (!input.matches('input.quantity__input[data-pack-multiple]')) return;
    const step = parseInt(input.getAttribute('data-pack-multiple'), 10);
    if (!step || step < 2) return;
    const min = parseInt(input.getAttribute('min') || step, 10) || step;

    const fixed = snap(input.value, step, min);
    if (String(fixed) !== String(input.value)) {
      input.value = fixed;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('blur', onSnap, true);
  document.addEventListener('change', onSnap, true);
})();
